import { type FC } from 'react';

import { AdfoxParallaxBottomBanner } from '../../components/AdfoxParallaxBottomBanner';
import { CrosslinksContainer } from '../../components/Crosslinks';
import { Footer } from '../../components/Footer';
import { MarkedListContainer } from '../../components/MarkedList';
import { TopHitsLinksContainer } from '../../components/TopHitsLinks';

export const FooterContainer: FC = () => {
  return (
    <Footer>
      <TopHitsLinksContainer />
      <CrosslinksContainer />
      <AdfoxParallaxBottomBanner />
      <MarkedListContainer />
    </Footer>
  );
};
